<template>
  <div class="onboarding_comp auth-input-page">
    <div class="auth-input-page__group">
      <label class="auth-label-input">Age group</label>
      <div class="selections">
        <div
          v-for="(age, index) in ageGroups"
          :key="index"
          class="selection"
          :class="{ _selected: ageRange == age.title }"
          @click="selectAgeRange(age)"
        >
          {{ age.title }}
        </div>
      </div>
    </div>

    <div class="auth-input-page__group mb-2">
      <label class="auth-label-input">Country</label>
      <input
        v-model="country"
        :class="{ _filled: country }"
        type="text"
        placeholder="Type your country"
      />
      <autocomplete
        :keyword="country"
        :options="getCountryList"
        identifier="country"
        @selected="selected"
        class="location"
      ></autocomplete>
    </div>

    <div class="auth-input-page__group">
      <label class="auth-label-input">City</label>
      <input
        v-model="city"
        :class="{ _filled: city }"
        type="text"
        placeholder="Type your city"
      />
      <autocomplete
        :keyword="city"
        :options="getCityList"
        identifier="city"
        @selected="selected"
        style="z-index: 1"
        class="location"
      ></autocomplete>
    </div>

    <VueLoadingButton
      @click.native="handleClick"
      :loading="isLoading"
      class="w-100"
    >
      <div
        :class="{
          'display-flex align-center gap-8 justify-space-between':
            $vuetify.breakpoint.width <= 1280,
        }"
      >
        <v-btn
          v-if="$vuetify.breakpoint.width <= 1280"
          class="back-button"
          @click="$emit('actionPrevStage')"
        >
          Back
        </v-btn>
        <v-btn
          :class="{
            _disabled: !validated('skipToast'),
            'auth-bg-disabled': checkDataEmpty,
            'auth-bg-active': !checkDataEmpty,
          }"
          class="auth-button"
          @click="handleNextStage()"
        >
          Next
        </v-btn>
      </div>
    </VueLoadingButton>
  </div>
</template>

<script>
import autocomplete from "@/components/autocomplete.vue";
import { mapActions, mapMutations, mapState } from "vuex";
import VueLoadingButton from "vue-loading-button";

export default {
  components: {
    autocomplete,
    VueLoadingButton,
  },
  data() {
    return {
      isLoading: false,
      ageRange: null,
      ageGroups: [
        {
          id: 1,
          title: "14-21",
        },
        {
          id: 2,
          title: "22-34",
        },
        {
          id: 3,
          title: "35-49",
        },
        {
          id: 4,
          title: "50-85+",
        },
      ],
      country: "",
      city: "",
      cityAutoActive: false,
      proceedToCities: false,
    };
  },
  computed: {
    ...mapState({
      current: (state) => state.app.onboarding.current,
      countries: (state) => state.app.countries,
      cities: (state) => state.app.cities,
      getAgeRange: (state) => state.app.onboarding.ageRange,
      getCountry: (state) => state.app.onboarding.country,
      getCity: (state) => state.app.onboarding.city,
    }),
    getCountryList() {
      const getCountries = this.countries.map((c) => c.country);
      const countries = getCountries.filter((country) => {
        if (country.toLowerCase().includes(this.country.toLowerCase())) {
          return country;
        }
      });

      return countries;
    },
    getCityList() {
      const cities = this.cities.filter((city) => {
        if (city.toLowerCase().includes(this.city.toLowerCase())) {
          return city;
        }
      });

      return cities;
    },
    checkDataEmpty() {
      return this.ageRange == null || this.country == "" || this.city == "";
    },
  },
  watch: {
    country() {
      this.proceedToCities = false;
    },
    proceedToCities(val) {
      if (val) {
        this.getCities(this.country);
      }
    },
  },
  methods: {
    ...mapActions({
      getCountries: "app/getCountries",
      getCities: "app/getCities",
      gotoNextStage: "app/nextOnboardingStage",
      gotoPrevStage: "app/prevOnboardingStage",
    }),
    ...mapMutations({
      updateOnboarding: "app/updateOnboarding",
    }),
    validated(toastStatus) {
      const skipToast = toastStatus === "skipToast";

      const { ageRange, country, city } = this;
      const valCountry = this.getCountryList.includes(country);
      const valCity = this.getCityList.includes(city);
      const toValidate = [ageRange, valCountry, valCity];

      const errors = [
        "Please choose an age range",
        "Please select a valid country from list",
        "Please select a valid city from list",
      ];

      const isValid = toValidate.every((item, index) => {
        if (!skipToast && !item) {
          this.$store.dispatch("error/showErrorToast", [errors[index]]);
          return item;
        }
        return item;
      });
      return isValid;
    },
    selectAgeRange(age) {
      this.ageRange = age.title;
    },
    selected(identifier, option) {
      switch (identifier) {
        case "country":
          this.country = option;
          this.city = "";

          // Bug: had to combine bothe false instance
          this.proceedToCities = true;
          this.$nextTick(() => {
            this.proceedToCities = true;
          });
          break;
        case "city":
          this.city = option;
          break;
        default:
          break;
      }
    },

    async handleNextStage() {
      if (this.validated()) {
        const data = {
          age_group: this.ageRange,
          country: this.country,
          city: this.city,
        };
        this.updateOnboarding(data);
        let user_params = this.$store.state.app.onboarding;
        this.gotoNextStage(this.current + 1);
      }
    },
    handlePrevStage() {
      if (this.current !== 1) {
        this.gotoPrevStage(this.current - 1);
      }
    },
    handleClick() {
      if (this.validated()) {
        this.isLoading = true;
        this.$store.dispatch("error/showLoadingActivity", true);
      }
    },
  },
  created() {
    this.getCountries();

    this.ageRange = this.getAgeRange;
    this.country = this.getCountry;
    this.city = this.getCity;
  },
};
</script>

<style lang="scss" scoped>
.selections {
  display: flex;
  justify-content: space-between;
  cursor: pointer;
  margin-bottom: 25px;
  gap: 11px;

  .selection {
    color: #000;
    font-feature-settings: "clig" off, "liga" off;
    font-family: Poppins;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    border-radius: 4px;
    background: #f2f2f2;
    width: 80px;
    height: 34px;
    display: flex;
    text-align: center;
    align-items: center;
    justify-content: center;

    &._selected {
      border-radius: 4px;
      border: 1px solid #4f56ff;
      background: #4f56ff;
      color: #fff;
    }
  }
}

.auth-input-page {
  &__group {
    display: flex;
    flex-direction: column;
    width: 354px;
  }
}

.auth-button {
  margin: 30px 0 0 !important;
  box-shadow: none !important;
  width: 100%;
}

.back-button {
  font-family: Inter;
  font-size: 18px;
  font-weight: 700;
  line-height: 18.68px;
  text-align: center;
  background: #0000000d;
  height: 50px;
  border-radius: 56px;
  margin: 30px 0 0 !important;
  box-shadow: none !important;
  width: 100%;
}

@media screen and (max-width: 1280px) {
  .auth-button {
    height: 50px !important;
    border-radius: 56px;
    font-size: 18px !important;
  }
}
</style>



// WEBPACK FOOTER //
// ageLocation.vue?019b26bd